import angular from 'angular';

import component from './cta-buttons-details.component';

const CtaButtonsDetails = angular
    .module('control-room.commons.form.components.cta-buttons-details', [])
    .component('crCtaButtonsDetails', component);

export default CtaButtonsDetails;
